import { render, staticRenderFns } from "./ProductionRatio.vue?vue&type=template&id=0a99c24c&scoped=true&"
import script from "./ProductionRatio.vue?vue&type=script&lang=js&"
export * from "./ProductionRatio.vue?vue&type=script&lang=js&"
import style0 from "./ProductionRatio.vue?vue&type=style&index=0&id=0a99c24c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a99c24c",
  null
  
)

export default component.exports